   <template>
    <b-card title="Asset Filters">
        <b-container fluid>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="fieldset-customer"
                        label="Customer"
                        label-for="input-officer"
                    >
                        <customer-type-ahead v-model="model.customer_id" />
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group
                        id="fieldset-assetType"
                        label="Asset Type"
                        label-for="input-assetType"
                    >
                        <b-form-select
                            id="input-assetType"
                            v-model="model.type_id"
                            value-field="id"
                            text-field="name"
                            :options="assetTypes"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="fieldset-warranty_from"
                        label="Warranty From"
                        label-for="input-warranty_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-warranty_from"
                            v-model="model.warranty_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group
                        id="fieldset-warranty_to"
                        label="Warranty To"
                        label-for="input-warranty_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-warranty_to"
                            v-model="model.warranty_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="fieldset-last_service_from"
                        label="Last Service From"
                        label-for="input-last_service_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-last_service_from"
                            v-model="model.last_service_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group
                        id="fieldset-last_service_to"
                        label="Last Service To"
                        label-for="input-last_service_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-last_service_to"
                            v-model="model.last_service_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="6">
                    <b-form-group
                        id="fieldset-next_service_from"
                        label="Next Service From"
                        label-for="input-next_service_from"
                    >
                        <b-form-input
                            type="date"
                            id="input-next_service_from"
                            v-model="model.next_service_from"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="6">
                    <b-form-group
                        id="fieldset-next_service_to"
                        label="Next Service To"
                        label-for="input-next_service_to"
                    >
                        <b-form-input
                            type="date"
                            id="input-next_service_to"
                            v-model="model.next_service_to"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>
    </b-card>
</template>

<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead'

const fromDate = new Date()
fromDate.setMonth(fromDate.getMonth() - 6)

const getDate = dateObj => {
    dateObj = dateObj || new Date()
    return dateObj.toISOString().split('T')[0]
}

export default {
    name: 'assets-reportQueryBuilder',
    components: { CustomerTypeAhead },
    data: () => ({
        model: {
            customer_id: 0,
            type_id: 0,

            next_service_from: getDate(fromDate),
            next_service_to: getDate(),

            last_service_from: getDate(fromDate),
            last_service_to: getDate(),

            warranty_from: getDate(fromDate),
            warranty_to: getDate(),
        },
    }),
    props: ['assetTypes'],

    watch: {
        model: {
            handler: function (val) {
                this.$emit('input', val)
            },
            deep: true,
        },

        'model.customer_id': function (val) {
            console.log('customer-id', val)
        },
    },
    mounted() {
        this.model = { ...this.value }
    },
}
</script>